import { ThemeModeType } from "../../../../../_metronic/partials";

export const getTheme = (mode: ThemeModeType, type: "skin" | "content", theme?: string) => {
    const currentThemeMode = mode === "system" ? window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light" : mode

    if (currentThemeMode === "light") {
        return type === "skin" ? "oxide" : "default"
    } else {
        switch (theme) {
            case "2023":
                return type === "skin" ? "app_2023_dark" : "/tinymce/skins/content/app_2023_dark/content.min.css"
            case "purple":
              return type === "skin" ? "app_purple_dark" : "/tinymce/skins/content/app_purple_dark/content.min.css"
            case "dark_purple":
                return type === "skin" ? "app_dark_purple_dark" : "/tinymce/skins/content/app_dark_purple_dark/content.min.css"
            case "orange":
              return type === "skin" ? "app_orange_dark" : "/tinymce/skins/content/app_orange_dark/content.min.css"
            case "dark_green":
              return type === "skin" ? "app_dark_green_dark" : "/tinymce/skins/content/app_dark_green_dark/content.min.css"
            case "green":
              return type === "skin" ? "app_green_dark" : "/tinymce/skins/content/app_green_dark/content.min.css"
            default:
                return type === "skin" ? "app_dark" : "/tinymce/skins/content/app_dark/content.min.css"
        }
    }
}